import { renderLucideIcon } from '../utils/lucide-icons.js'

function normalizeDictationWritingResultUi(result) {
  if (!result || typeof result !== 'object') return null
  var ui = result.ui || result.dictationWritingResultUi || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'dictation-writing-result') return null

  var operations = Array.isArray(ui.operations)
    ? ui.operations.map(normalizeOperation).filter(Boolean)
    : []
  if (!operations.length) return null

  return {
    type: 'dictation-writing-result',
    title: String(ui.title || resolveTitle(ui.status)).trim(),
    status: normalizeStatus(ui.status, operations),
    message: String(ui.message || '').trim(),
    operations: operations
  }
}

function renderDictationWritingResultUi(ui) {
  return (
    '<div class="wc-dictation-writing-result is-' + escapeAttributeValue(ui.status) + '" data-ds-view="dictation-writing-result">' +
      '<div class="wc-ds-capability wc-ds-capability-dictation">' +
        '<div class="wc-ds-capability-name">' + renderLucideIcon('mic') + '<span>@Dictée</span></div>' +
      '</div>' +
      '<div class="wc-dictation-writing-result-panel">' +
        '<div class="wc-dictation-writing-result-section-title">' + renderLucideIcon(iconForResultStatus(ui.status)) + '<span>Actions exécutées</span></div>' +
        '<div class="wc-dictation-writing-result-list">' +
          ui.operations.map(renderOperation).join('') +
        '</div>' +
      '</div>' +
    '</div>'
  )
}

function normalizeOperation(value) {
  if (!value || typeof value !== 'object') return null
  var objectType = String(value.objectType || '').trim()
  var label = String(value.label || '').trim()
  var status = String(value.status || '').trim()
  if (!objectType || !label || !['succeeded', 'failed', 'reused', 'not_executed'].includes(status)) return null
  return {
    objectType: objectType,
    label: label,
    status: status,
    recordId: String(value.recordId || '').trim() || null,
    syncLabel: String(value.syncLabel || '').trim() || null,
    sentence: String(value.sentence || '').trim() || null,
    error: String(value.error || '').trim() || null
  }
}

function renderOperation(operation) {
  return (
    '<div class="wc-dictation-writing-result-operation is-' + escapeAttributeValue(operation.status) + '">' +
      '<span class="wc-dictation-writing-result-object">' + renderLucideIcon(iconForObjectType(operation.objectType)) + '</span>' +
      '<div class="wc-dictation-writing-result-operation-body">' +
        '<div class="wc-dictation-writing-result-operation-top">' +
          '<span class="wc-dictation-writing-result-operation-label">' + escapeHtml(operation.sentence || operation.label) + '</span>' +
          '<span class="wc-dictation-writing-result-pill">' + renderLucideIcon(iconForOperationStatus(operation.status)) + '<span>' + escapeHtml(labelForOperationStatus(operation.status)) + '</span></span>' +
        '</div>' +
        (operation.syncLabel ? '<div class="wc-dictation-writing-result-operation-meta">Synchronisation : ' + escapeHtml(operation.syncLabel) + '</div>' : '') +
        (operation.error ? '<div class="wc-dictation-writing-result-error">' + escapeHtml(operation.error) + '</div>' : '') +
      '</div>' +
    '</div>'
  )
}

function normalizeStatus(value, operations) {
  var status = String(value || '').trim()
  if (['success', 'partial', 'failed', 'cancelled', 'not_executed'].includes(status)) return status
  if (operations.some(function (operation) { return operation.status === 'failed' })) return 'failed'
  if (operations.every(function (operation) { return operation.status === 'not_executed' })) return 'not_executed'
  if (operations.some(function (operation) { return operation.status === 'not_executed' })) return 'partial'
  return 'success'
}

function resolveTitle(status) {
  status = String(status || '').trim()
  if (status === 'failed') return 'Écriture non réalisée'
  if (status === 'partial') return 'Plan partiellement exécuté'
  if (status === 'not_executed') return 'Aucune écriture exécutée'
  return 'Plan exécuté'
}

function iconForResultStatus(status) {
  if (status === 'success') return 'circleCheck'
  if (status === 'failed') return 'triangleAlert'
  if (status === 'not_executed') return 'badgeInfo'
  return 'triangleAlert'
}

function iconForOperationStatus(status) {
  if (status === 'succeeded') return 'circleCheck'
  if (status === 'reused') return 'refreshCcw'
  if (status === 'not_executed') return 'badgeInfo'
  return 'triangleAlert'
}

function labelForOperationStatus(status) {
  if (status === 'succeeded') return 'Réalisé'
  if (status === 'reused') return 'Réutilisé'
  if (status === 'not_executed') return 'Non exécuté'
  return 'Échec'
}

function iconForObjectType(objectType) {
  if (objectType === 'contact') return 'userRound'
  if (objectType === 'entity') return 'building2'
  if (objectType === 'deal') return 'handshake'
  if (objectType === 'activity') return 'calendarCheck'
  return 'box'
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapeAttributeValue(value) {
  return escapeHtml(value).replace(/`/g, '&#96;')
}

export { normalizeDictationWritingResultUi, renderDictationWritingResultUi }
